import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';
import { referafriendPostDataInterface, reorderPostDataInterface, updatePasswordPostDataInterface, updateUserPostDataInterface } from 'src/_lib/interfaces/request-interfaces/my-account.interface';
import { orderKey } from 'src/_lib/interfaces/common.interface';
import { getsaveforDataInterface } from 'src/_lib/interfaces/request-interfaces/wishlist-popup.interface';

@Injectable({
  providedIn: 'root',
})
export class MyprofileService {
  private endpoint: string = environment.apiUrl;

  constructor(
    private http: HttpClient){}

  /** Get user Details **/
  getUserDetails(): Observable<any> {
    return this.http.get<any>(this.endpoint + 'get-user',);
  }

   /** Update User Password **/
  updatePassword(data: updatePasswordPostDataInterface): Observable<any> {
    const url = `${this.endpoint}update-password`;
    return this.http.put(url, data);
  }

   /** Refer A Friend **/
  referFriend(data: referafriendPostDataInterface): Observable<any>{
    const url = `${this.endpoint}refer-a-friend`;
    return this.http.post(url, data);
  }

  /* updateUserDetails(data:any): Observable<any> {
    return this.http.put<any>(this.endpoint + 'update-user', data);
  }*/

   /** Update user Details **/
  updateUserDetails(data: updateUserPostDataInterface): Observable<any> {
    const url = `${this.endpoint}updateuser`;
    return this.http.put(url, data);
  }

   /** Get user order Details **/
  getUserOrderData(data:any) {
    return this.http.post(this.endpoint + 'get-user-orders', data);
  }

   /** Get user wishlist Details **/
  getUserWishlistData() {
    return this.http.post(this.endpoint + 'get-user-wishlist',{});
  }

  /**Reorder**/
  reorder(data: reorderPostDataInterface){
    return this.http.post(this.endpoint + 'reorder', data);
  }

  /*** order Invoice****/
  getOrderInvoice(data: orderKey){
    return this.http.post(this.endpoint + 'track-your-order', data);
  }

  printOrderInvoice(data: orderKey){
    return this.http.post(this.endpoint + 'generate-pdf', data);
  }

  /**get products in save for later */
  getSaveForLaterproducts(data :getsaveforDataInterface){
    return this.http.post(this.endpoint + 'get-user-wishlist', data)
  }

  removefromSaveforLater(product_variation_key: number, save_for_later:boolean) {
    return this.http.delete(this.endpoint + 'remove-wishlist-item', {
      params: {
        product_variation_key: product_variation_key,
        save_for_later: save_for_later
      }
    });
  }

  removefromwishList(product_variation_key: number) {
    return this.http.delete(this.endpoint + 'remove-wishlist-item', {
      params: {
        product_variation_key: product_variation_key,
      }
    });
  }

  getOrdersByDateRange(startDate: string, endDate: string): Observable<any[]> {
    const body = {
      start_date: startDate,
      end_date: endDate
    };

    return this.http.post<any[]>(this.endpoint +'get-user-orders-monthly', body);
  }
}
